import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type X5Machine } from "@packsize/schemas/machines";

import { getX5Machine } from "@/api/machines/x5-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { X5_MACHINES_QUERY_KEY } from "./query-keys";

type UseX5MachineQueryOptions = UseMachinesQueryOptions<X5Machine | null, Error>;

export const getX5MachineQuery = (machineId: string | null | undefined, options?: UseX5MachineQueryOptions) => ({
	queryKey: [...X5_MACHINES_QUERY_KEY, { machineId }],
	queryFn: () => getX5Machine(machineId || ""),
	...options,
	enabled: Boolean(machineId) && (options?.enabled ?? true),
});

export const useX5Machine = (
	machineId: string | null | undefined,
	options?: UseX5MachineQueryOptions,
): UseQueryResult<X5Machine | null, Error> => {
	return useQuery<X5Machine | null, Error>(getX5MachineQuery(machineId, options));
};
